import * as React from "react";
import { AspectRatio } from "./";
import { SvgSprite } from "./SvgSprite";
import { OpportunitySearchTypes } from "../types";

interface ResultSearchTypeBreakProps {
  opportunitySearchType: OpportunitySearchTypes;
}

export const ResultSearchTypeBreak: React.FC<ResultSearchTypeBreakProps> = ({
  opportunitySearchType,
}) => {
  const summary = React.useMemo(() => {
    if (process.env.TARGET_ENV === "au" || process.env.TARGET_ENV === "nsw") {
      switch (opportunitySearchType) {
        case OpportunitySearchTypes.NoLocation:
        default:
          return null;
        case OpportunitySearchTypes.LocationSuburb:
          return (
            <p>
              We found more opportunities in the
              <br /> <strong>surrounding suburbs and areas</strong>
            </p>
          );
        case OpportunitySearchTypes.LocationRegional:
          return (
            <p>
              We found more opportunities that are
              <br /> <strong>state wide or remote</strong>
            </p>
          );
        case OpportunitySearchTypes.LocationMetro:
          return (
            <p>
              We found more opportunities in the
              <br /> <strong>surrounding areas</strong>
            </p>
          );
        case OpportunitySearchTypes.LocationStateRegion:
          return (
            <p>
              We found more opportunities that are
              <br /> <strong>remote</strong>
            </p>
          );
      }
    }

    if (process.env.TARGET_ENV === "nz") {
      switch (opportunitySearchType) {
        case OpportunitySearchTypes.NoLocation:
        default:
          return null;
        case OpportunitySearchTypes.LocationSuburb:
          return (
            <p>
              We found more opportunities in the
              <br /> <strong>surrounding suburbs and areas</strong>
            </p>
          );
        case OpportunitySearchTypes.LocationRegional:
          return (
            <p>
              We found more opportunities in the
              <br /> <strong>surrounding areas</strong>
            </p>
          );
        case OpportunitySearchTypes.LocationMetro:
          return (
            <p>
              We found more opportunities in the
              <br /> <strong>surrounding areas</strong>
            </p>
          );
        case OpportunitySearchTypes.LocationStateRegion:
          return (
            <p>
              We found more opportunities that are
              <br /> <strong>remote</strong>
            </p>
          );
      }
    }
  }, [opportunitySearchType]);

  return (
    <div
      css={`
        max-width: 440px;
        margin: 0 auto;
      `}
    >
      <AspectRatio className="mb-2" width={439} height={78}>
        <SvgSprite id="illustrations:01B" />
      </AspectRatio>
      {summary}
    </div>
  );
};
